//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    name: "SubmitComment",
    props: {
        username: String,
        comment: String
    },
    data() {
        return {};
    }
};
